import Swal from "sweetalert2"
import { ref, computed } from "vue"
export function useHabitaciones() {

  const habitaciones = ref([
    {
      adultos: 2,
      ninos: 0,
      infantes: 0,
      edadesNinos: [],
      edadesInfantes: []
    }
  ])

  const maxHabitaciones = 4

  // =========================
  // SYNC EDADES
  // =========================
  function syncEdades() {
    habitaciones.value.forEach(h => {

      while (h.edadesNinos.length < h.ninos) {
        h.edadesNinos.push(5)
      }
      while (h.edadesNinos.length > h.ninos) {
        h.edadesNinos.pop()
      }

      while (h.edadesInfantes.length < h.infantes) {
        h.edadesInfantes.push(1)
      }
      while (h.edadesInfantes.length > h.infantes) {
        h.edadesInfantes.pop()
      }

    })
  }

  // =========================
  // SETTERS
  // =========================
  function setAdultos(index, value) {
    habitaciones.value[index].adultos = Number(value)
  }

  function setNinos(index, value) {
    habitaciones.value[index].ninos = Number(value)
    syncEdades()
  }

  function setInfantes(index, value) {
    habitaciones.value[index].infantes = Number(value)
    syncEdades()
  }

  // =========================
  // CRUD
  // =========================
  function agregarHabitacion() {
    if (habitaciones.value.length >= maxHabitaciones) return

    habitaciones.value.push({
      adultos: 2,
      ninos: 0,
      infantes: 0,
      edadesNinos: [],
      edadesInfantes: []
    })
  }

  function eliminarHabitacion() {
    if (habitaciones.value.length <= 1) return
    habitaciones.value.pop()
  }

  // =========================
  // VALIDACIONES
  // =========================
  function validarPasajeros() {
    const total = habitaciones.value.reduce((acc, h) =>
      acc + h.adultos + h.ninos + h.infantes, 0)

    if (total > 9) {
      Swal.fire({
        icon: "warning",
        title: "Máximo 9 pasajeros"
      })
      return false
    }
    return true
  }

  // =========================
  // TOTALES
  // =========================
  function totales() {
    let adultos = 0, ninos = 0, infantes = 0
    let edadesNinos = [], edadesInfantes = []

    habitaciones.value.forEach(h => {
      adultos += h.adultos
      ninos += h.ninos
      infantes += h.infantes
      edadesNinos.push(...h.edadesNinos)
      edadesInfantes.push(...h.edadesInfantes)
    })

    return { adultos, ninos, infantes, edadesNinos, edadesInfantes }
  }
  const totalPersonas = computed(() => {

    return habitaciones.value.reduce((acc, h) => {

      return acc +
        Number(h.adultos) +
        Number(h.ninos) +
        Number(h.infantes)

    }, 0)

  })
  return {
    habitaciones,
    agregarHabitacion,
    eliminarHabitacion,
    validarPasajeros,
    totales,
    setAdultos,
    setNinos,
    setInfantes,
    totalPersonas
  }
}